<template>
	<a-page-header
		class="mb-5"
		style="border: 1px solid rgb(235, 237, 240);"
		:title="detail.profileName"
		:sub-title="
			'wrote this post ' +
				moment(post.createdAt)
					.utc()
					.fromNow()
		"
		@back="() => $router.go(-1)"
	>
		<a-row type="flex">
			<a-statistic title="Likes" :value="post.likes" class="mr-4">
				<template #prefix>
					<a-icon type="like" />
				</template>
			</a-statistic>
			<a-statistic
				title="Views"
				:value="post.views"
				class="mr-4"
				v-if="post.isVideo"
			>
				<template #prefix>
					<a-icon type="eye" />
				</template>
			</a-statistic>
			<a-statistic title="Comments" :value="post.comments" class="mr-4">
				<template #prefix>
					<a-icon type="message" />
				</template>
			</a-statistic>
			<a-statistic title="Engagement" :value="post.engagement" class="mr-4" />
			<a-statistic
				title="Ranking"
				:value="loadingRank ? '' : ranking"
				class="mr-4"
			>
				<template #prefix>
					<a-icon type="loading" v-if="loadingRank" />
					<a-icon type="number" v-else />
				</template>
				<template #suffix v-if="!loadingRank">
					{{ numberPrefix(ranking) }}
				</template>
			</a-statistic>
		</a-row>
	</a-page-header>
</template>

<script>
import { mapActions } from 'vuex'
import * as ACTIONS from '@/store/actions'
import moment from 'moment'

export default {
	name: 'PostTitle',
	props: {
		post: {
			type: Object,
			required: true,
		},
		detail: {
			type: Object,
			required: true,
		},
	},
	data: function() {
		return {
			moment,
			ranking: 0,
			loadingRank: true,
		}
	},
	created() {
		let { detailId, code } = this.post

		this.loadPostRank({ detailId, code }).then(res => {
			this.loadingRank = false
			this.ranking = res.ranking
		})
	},
	methods: {
		numberPrefix(n) {
			let s = ['th', 'st', 'nd', 'rd']
			let v = n % 100
			return s[(v - 20) % 10] || s[v] || s[0]
		},
		...mapActions({
			loadPostRank: ACTIONS.POST.RANK,
		}),
	},
}
</script>

<style></style>
